module.exports = __webpack_public_path__ + "img/thumb-009-13.2b92f760.png";